export type CalcProgress = {
    percent: number;
    message: string;
};

export const DEFAULT_PROGRESS: CalcProgress = { percent: 0, message: '' };

export type StoredCalcProgresses = {
    [operatingSetupId: string]: CalcProgress;
};
